import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const VideoWatch = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [video, setVideo] = useState(null);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [loading, setLoading] = useState(true);
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [showShare, setShowShare] = useState(false);
  const [showViewers, setShowViewers] = useState(false);
  const [viewers, setViewers] = useState([]);
  const [subscribed, setSubscribed] = useState(false);
  const [subscribers, setSubscribers] = useState(0);
  const [viewCounted, setViewCounted] = useState(false);
  const videoRef = useRef(null);
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchVideo();
    fetchComments();
  }, [id]);

  const fetchVideo = async () => {
    try {
      const headers = token ? { Authorization: `Token ${token}` } : {};
      const res = await axios.get(`/api/videos/${id}/`, { headers });
      setVideo(res.data);
      setLiked(res.data.is_liked);
      setLikesCount(res.data.likes_count);
      setSubscribed(res.data.is_subscribed);
      setSubscribers(res.data.subscribers);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const fetchComments = async () => {
    try {
      const headers = token ? { Authorization: `Token ${token}` } : {};
      const res = await axios.get(`/api/videos/${id}/comments/`, { headers });
      setComments(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchViewers = async () => {
    try {
      const res = await axios.get(`/api/videos/${id}/viewers/`);
      setViewers(res.data.viewers || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleVideoEnded = async () => {
    if (!viewCounted) {
      setViewCounted(true);
      try {
        const headers = token ? { Authorization: `Token ${token}` } : {};
        await axios.post(`/api/videos/${id}/view/`, {}, { headers });
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleLike = async () => {
    if (!token) return alert('Please login first');
    try {
      const res = await axios.post(`/api/videos/${id}/like/`, {}, {
        headers: { Authorization: `Token ${token}` }
      });
      setLiked(res.data.liked);
      setLikesCount(res.data.likes_count);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubscribe = async () => {
    if (!token) return alert('Please login first');
    try {
      const res = await axios.post(`/api/videos/channel/${video.uploader}/subscribe/`, {}, {
        headers: { Authorization: `Token ${token}` }
      });
      setSubscribed(res.data.subscribed);
      setSubscribers(res.data.subscribers);
    } catch (err) {
      console.error(err);
    }
  };

  const handleComment = async (e) => {
    e.preventDefault();
    if (!token) return alert('Please login first');
    if (!newComment.trim()) return;
    try {
      const res = await axios.post(`/api/videos/${id}/comments/`, { content: newComment }, {
        headers: { Authorization: `Token ${token}` }
      });
      setComments([res.data, ...comments]);
      setNewComment('');
    } catch (err) {
      console.error(err);
    }
  };

  const formatDuration = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  if (loading) return <div style={{ color: '#aaa', textAlign: 'center', padding: '40px' }}>Loading...</div>;
  if (!video) return <div style={{ color: '#aaa', textAlign: 'center', padding: '40px' }}>Video not found</div>;

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
      <button onClick={() => navigate('/videos')} style={{ background: 'transparent', border: 'none', color: '#aaa', cursor: 'pointer', marginBottom: '16px', fontSize: '14px' }}>
        ← Back to Videos
      </button>

      {/* Video Player */}
      <video
        ref={videoRef}
        controls
        autoPlay
        src={video.video_url}
        onEnded={handleVideoEnded}
        style={{ width: '100%', borderRadius: '12px', background: '#000', maxHeight: '500px' }}
      />

      {/* Title */}
      <h2 style={{ color: '#fff', margin: '16px 0 8px' }}>{video.title}</h2>

      {/* Stats Row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '12px' }}>
        <div style={{ color: '#aaa', fontSize: '14px', display: 'flex', gap: '16px', alignItems: 'center' }}>
          <button
            onClick={() => { setShowViewers(!showViewers); if (!showViewers) fetchViewers(); }}
            style={{ background: 'none', border: 'none', color: '#aaa', cursor: 'pointer', fontSize: '14px', padding: 0 }}
          >
            👁 {video.views_count} views
          </button>
          <span>⏱ {formatDuration(video.duration)}</span>
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button onClick={handleLike}
            style={{ background: liked ? '#0F6E56' : '#1e2a3a', color: liked ? '#000' : '#fff', border: 'none', borderRadius: '20px', padding: '8px 16px', cursor: 'pointer', fontWeight: 'bold' }}>
            {liked ? '❤️' : '🤍'} {likesCount}
          </button>
          <button onClick={() => setShowShare(!showShare)}
            style={{ background: '#1e2a3a', color: '#fff', border: '1px solid #444', borderRadius: '20px', padding: '8px 16px', cursor: 'pointer', fontSize: '14px' }}>
            ↗ Share
          </button>
        </div>
      </div>

      {/* Viewers Popup */}
      {showViewers && (
        <div style={{ background: '#1e2a3a', borderRadius: '8px', padding: '16px', marginBottom: '12px' }}>
          <div style={{ color: '#fff', fontWeight: 'bold', marginBottom: '12px' }}>👁 Who watched this video</div>
          {viewers.length === 0 ? (
            <div style={{ color: '#aaa', fontSize: '13px' }}>No registered viewers yet</div>
          ) : viewers.map((v, i) => (
            <div key={i} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #2a3a4a' }}>
              <span
                onClick={() => navigate(`/profile/${v.username}`)}
                style={{ color: '#0F6E56', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}
              >
                @{v.username}
              </span>
              <span style={{ color: '#aaa', fontSize: '12px' }}>{v.watched_at}</span>
            </div>
          ))}
        </div>
      )}

      {/* Share Popup */}
      {showShare && (
        <div style={{ background: '#1e2a3a', border: '1px solid #444', borderRadius: '12px', padding: '16px', marginBottom: '12px' }}>
          <div style={{ color: '#fff', fontWeight: 'bold', marginBottom: '12px' }}>🔗 Share this video</div>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
            <input readOnly value={`${window.location.origin}/videos/${video.id}`}
              style={{ flex: 1, padding: '8px', background: '#0d1b2a', border: '1px solid #333', borderRadius: '8px', color: '#aaa', fontSize: '12px' }} />
            <button onClick={() => { navigator.clipboard.writeText(`${window.location.origin}/videos/${video.id}`); alert('Link copied!'); }}
              style={{ background: '#0F6E56', color: '#000', border: 'none', borderRadius: '8px', padding: '8px 12px', cursor: 'pointer', fontWeight: 'bold', fontSize: '12px' }}>
              Copy
            </button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            <a href={`https://wa.me/?text=${video.title} ${window.location.origin}/videos/${video.id}`} target="_blank" rel="noreferrer"
              style={{ background: '#25d366', color: '#fff', borderRadius: '8px', padding: '10px', textDecoration: 'none', textAlign: 'center', fontSize: '13px', fontWeight: '600' }}>
              📱 WhatsApp
            </a>
            <a href={`https://twitter.com/intent/tweet?url=${window.location.origin}/videos/${video.id}&text=${video.title}`} target="_blank" rel="noreferrer"
              style={{ background: '#1da1f2', color: '#fff', borderRadius: '8px', padding: '10px', textDecoration: 'none', textAlign: 'center', fontSize: '13px', fontWeight: '600' }}>
              🐦 Twitter/X
            </a>
            <a href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.origin}/videos/${video.id}`} target="_blank" rel="noreferrer"
              style={{ background: '#1877f2', color: '#fff', borderRadius: '8px', padding: '10px', textDecoration: 'none', textAlign: 'center', fontSize: '13px', fontWeight: '600' }}>
              📘 Facebook
            </a>
            <a href={`${window.location.origin}/videos/channel/${video.uploader}`}
              style={{ background: '#0F6E56', color: '#000', borderRadius: '8px', padding: '10px', textDecoration: 'none', textAlign: 'center', fontSize: '13px', fontWeight: '600' }}>
              🎬 Channel
            </a>
            <button onClick={() => { navigator.clipboard.writeText(`<iframe src="${window.location.origin}/videos/${video.id}" width="560" height="315" frameborder="0" allowfullscreen></iframe>`); alert('Embed code copied!'); }}
              style={{ background: '#333', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px', cursor: 'pointer', fontSize: '13px', fontWeight: '600', gridColumn: 'span 2' }}>
              {'</>'} Copy Embed Code
            </button>
          </div>
          <button onClick={() => setShowShare(false)}
            style={{ marginTop: '12px', width: '100%', background: 'none', border: 'none', color: '#aaa', cursor: 'pointer', fontSize: '12px' }}>
            Close
          </button>
        </div>
      )}

      {/* Channel Info + Subscribe */}
      <div style={{ background: '#1e2a3a', borderRadius: '12px', padding: '16px', marginBottom: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div
            onClick={() => navigate(`/videos/channel/${video.uploader}`)}
            style={{ width: '48px', height: '48px', borderRadius: '50%', background: '#0F6E56', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', fontWeight: 'bold', color: '#000', cursor: 'pointer' }}>
            {video.uploader[0].toUpperCase()}
          </div>
          <div>
            <div
              onClick={() => navigate(`/videos/channel/${video.uploader}`)}
              style={{ color: '#fff', fontWeight: 'bold', cursor: 'pointer', fontSize: '15px' }}>
              @{video.uploader}
            </div>
            <div style={{ color: '#aaa', fontSize: '12px' }}>{subscribers} subscribers</div>
          </div>
        </div>
        <button onClick={handleSubscribe}
          style={{ background: subscribed ? '#333' : '#0F6E56', color: subscribed ? '#aaa' : '#000', border: 'none', borderRadius: '20px', padding: '10px 24px', fontWeight: '600', cursor: 'pointer', fontSize: '14px' }}>
          {subscribed ? '✓ Subscribed' : '+ Subscribe'}
        </button>
      </div>

      {/* Description */}
      {video.description && (
        <div style={{ background: '#1e2a3a', borderRadius: '8px', padding: '12px', marginBottom: '16px', color: '#ccc', fontSize: '14px' }}>
          {video.description}
        </div>
      )}

      {/* Comments */}
      <div>
        <h3 style={{ color: '#fff', marginBottom: '16px' }}>💬 Comments ({video.comments_count})</h3>
        {token && (
          <form onSubmit={handleComment} style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
            <input value={newComment} onChange={e => setNewComment(e.target.value)} placeholder="Write a comment..."
              style={{ flex: 1, padding: '10px', borderRadius: '8px', border: 'none', background: '#1e2a3a', color: '#fff' }} />
            <button type="submit" style={{ background: '#0F6E56', color: '#000', border: 'none', borderRadius: '8px', padding: '10px 16px', fontWeight: 'bold', cursor: 'pointer' }}>
              Post
            </button>
          </form>
        )}
        {comments.map(c => (
          <div key={c.id} style={{ background: '#1e2a3a', borderRadius: '8px', padding: '12px', marginBottom: '10px' }}>
            <div
              onClick={() => navigate(`/profile/${c.user}`)}
              style={{ color: '#0F6E56', fontSize: '13px', fontWeight: 'bold', marginBottom: '4px', cursor: 'pointer' }}>
              @{c.user}
            </div>
            <div style={{ color: '#fff', fontSize: '14px' }}>{c.content}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VideoWatch;
